<template>
  <div class="criterio-select-lojas">
    <span class="criterio-subtitle"> {{ label }} </span>

    <v-row>
      <v-flex class="select-container pt-2" xs12>
        <mf-select-units-dialog
          hide-details
          required
          outlined
          units-label=""
          enable-inactive-units-selection
          :disable-save="disableSave"
          :selected-units.sync="unitsIds"
          :selected-units-configuration.sync="units"
          :units="allUnits"
          :tag-list="tagList"
          :group-list="unitsGroups"
          @change="input"
        />
      </v-flex>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    values: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    disableSave: {
      type: Boolean,
      default: false,
    },
    componentParams: {
      type: String,
      validator: (val) => ['allowEmpty'].includes(val),
    },
  },

  data: () => ({
    unitsIds: [],
    units: [],
  }),

  computed: {
    ...mapGetters(['tagList', 'unitsGroups']),
    allUnits() {
      return this.$store.getters.units
    },
  },

  async mounted() {
    if (this.initialValue && this.initialValue.length > 0) this.setInitialValue()
    this.validate()
  },

  methods: {
    input() {
      this.$emit('input', { currentValue: this.units, currentChildren: this.values[0], currentIndex: this.currentIndex })
      this.validate()
    },

    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },

    isValid() {
      if (this.componentParams === 'allowEmpty') {
        return true
      }
      return Boolean(this.units && this.units.length)
    },

    setInitialValue() {
      const type = typeof this.initialValue[0]
      if (type === 'string') this.unitsIds = this.initialValue
      else {
        this.unitsIds = this.initialValue.map((unit) => unit.value)
        this.units = this.initialValue
      }
    },
  },
}
</script>

<style lang="scss">
.criterio-select-lojas {
  .select-container {
    padding: 0 15px;
  }
}
</style>
